var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon36ActionsCheckamark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-36-actions-checkamark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 36,
    height: 36,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M15,30A15,15,0,1,1,30,15,15.017,15.017,0,0,1,15,30ZM15,3A12,12,0,1,0,27,15,12.014,12.014,0,0,0,15,3ZM12.525,20.253A.722.722,0,0,1,12,20.025L8.475,16.47a.748.748,0,0,1,0-1.065l.8-.8a.72.72,0,0,1,1.049,0l2.25,2.236L19.68,9.735a.75.75,0,0,1,1.05,0l.749.8a.753.753,0,0,1,.221.532.745.745,0,0,1-.221.533l-8.429,8.429A.722.722,0,0,1,12.525,20.253Z",
    transform: "translate(3 3)",
    fill: "#3ae374"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon36ActionsCheckamark);
export default __webpack_public_path__ + "static/media/icon-36-actions-checkamark.f384c3b692ceab9d96049a5e9c472f32.svg";
export { ForwardRef as ReactComponent };